import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { cn } from "@/shared/lib/utils";
import styles from "./Accordion.module.scss";
const Chevron = () => (_jsx("svg", { viewBox: "0 0 18 18", fill: "none", stroke: "currentColor", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true", width: "18", height: "18", children: _jsx("path", { d: "M4.5 7l4.5 4.5L13.5 7" }) }));
/**
 * Multi-item disclosure list. Each item collapses/expands independently —
 * unlike a tabs-style accordion that only allows one open at a time.
 * Built on native <details>/<summary> for free keyboard/screen-reader support.
 */
export const Accordion = ({ items, defaultOpenId, className, }) => {
    return (_jsx("div", { className: cn(styles.root, className), children: items.map((item) => (_jsxs("details", { className: styles.item, open: defaultOpenId === item.id, children: [_jsxs("summary", { className: styles.summary, children: [_jsx("span", { children: item.title }), _jsx("span", { className: styles.icon, children: _jsx(Chevron, {}) })] }), _jsx("div", { className: styles.panel, children: item.content })] }, item.id))) }));
};
